import debug from 'debug'
import { postMessageToServer } from 'redux/ably/sagas';

class LoggerImplementer {
  public create: (namespace: string) => (args: any[] | any) => void = (namespace) => {
    return (...args) => {
      debug(namespace)(...args)
      postMessageToServer('client_log', `${new Date().toISOString()} - ${namespace}:${JSON.stringify(args)}`)
    }
  }
}

export const Logger = new LoggerImplementer();